<template functional>
  <div class="ui basic segment">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Segment'
}
</script>

<style scoped>
.ui.basic.segment {
  padding-left: 0;
  padding-right: 0;
}
</style>
